// extracted by mini-css-extract-plugin
module.exports = {"form":"TestForm_form__3c0yu"};